import { Component, Input, OnInit } from '@angular/core';
import { Atividade } from 'src/app/core/atividade';
import { DataUtilService } from '../../../services/commons/data-util.service';




@Component({
  selector: 'dados-atividade',
  templateUrl: './dados-atividade.component.html',
  styleUrls: ['./dados-atividade.component.css']
})
export class DadosAtividadeComponent implements OnInit {

  @Input() atividade: Atividade;

  constructor(private dataUtilService: DataUtilService) { }

  ngOnInit() { }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

}
